import React, { useEffect, useState, useRef } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Col, Row, Space } from 'antd'
import { PrimaryButton } from 'Components/button'
import {
  formatDateTime,
  formatDateWithoutTime,
  formatShippingTypes,
  getConfigByKey,
  getQuotationStatus,
} from 'helpers/format'
import { QuotationDetailReq, UpdateQuotationStatusReq } from 'Store/quotation/types'
import { getQuotationDetailAPI, updateQuotationStatusAPI } from 'Store/quotation/api'
import {
  selectQuotationActionEvent,
  selectQuotationDetail,
  selectQuotationDetailEvent,
} from 'Store/quotation/selector'
import { selectCurrentUser } from 'Store/user/selector'
import EventModal from 'Components/modal/EventModal'
import { clearEventAction } from 'Store/quotation/actions'
import LoadingView from 'Components/modal/LoadingView'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import ProductsTable from './components/ProductsTable'
import { selectAllSupplierList } from 'Store/supplier/selector'
import { InfoItem } from 'Pages/Merchants/components'
import { FranchiseTag, StatusTag } from 'Components/utilities'
import { ConfirmQuestion } from 'Components/modal'
import QuotationPDF from './components/QuotationPDF'
import { DocumentConfigKey, QuotationStatus } from 'helpers/constanst'
import DetailHeader from './components/DetailHeader'
import { selectDatas } from 'Store/config/selector'
import { GrnProductsListReq } from 'Store/stock/types'
import { getProductsGrnListAPI } from 'Store/stock/api'
import { selectProductsGrnList } from 'Store/stock/selector'
import ConfirmQuotation from './components/ConfirmQuotation'
import QuotationSummay from './components/QuotationSummay'
import { getConfigAPI } from 'Store/pos/api'
import { selectConfig, selectConfigList } from 'Store/pos/selector'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
  id?: number
}

const QuotationDetail: React.FunctionComponent<Props> = props => {
  const {
    onCloseDrawer,
    visible,
    currentUser,
    event,
    onSuccess = () => {},
    id = 0,
    detail,
    detailEvent,
    configs,
    productsGrn,
    configList,
  } = props

  const dispatch = useDispatch()
  const [rejectDialog, setRejectDialog] = useState(false)
  const [closeQuotationDialog, setCloseQuotationDialog] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const quotationPDF = useRef(null as any)
  const quotationLitePDF = useRef(null as any)
  const priceLabel = configs?.value.price_labels || []
  const configData = getConfigByKey(configList, DocumentConfigKey.QUOTATION)
  const config = configData && configData?.config_value && JSON.parse(configData?.config_value || '')
  const showVat = config?.enableTax || false

  useEffect(() => {
    if (visible) {
      onGetDetail()
    }
  }, [visible])

  useEffect(() => {
    if (visible && detail && detail?.status === QuotationStatus.PENDING) {
      onGetProductsGrn()
    }
  }, [detail, detail?.products])

  const onGetDetail = (): void => {
    const req: QuotationDetailReq = {
      id,
    }
    dispatch(getQuotationDetailAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const getProductOptionID = () => {
    const ids = [] as {
      product_id: number
      product_option_id: number
    }[]
    detail &&
      detail.products &&
      detail.products.forEach(item => {
        if (item.product_id !== 0 && item.product_option_id !== 0 && item.sale_item_type !== 'overstock') {
          ids.push({
            product_id: item.product_id,
            product_option_id: item.product_option_id,
          })
        }
      })
    return ids
  }

  const onGetProductsGrn = (): void => {
    const req: GrnProductsListReq = {
      product_ids: getProductOptionID(),
      is_out_of_stock: false,
      all: false,
    }
    dispatch(getProductsGrnListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onConfirmCancel = (status: QuotationStatus, reason: string): void => {
    setRejectDialog(false)
    const req: UpdateQuotationStatusReq = {
      id,
      reason,
      // username: userInfo?.username || '',
    }
    dispatch(updateQuotationStatusAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onClickCancel = (): void => {
    setRejectDialog(true)
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    setRejectDialog(false)
    setCloseQuotationDialog(false)
    clearEvent()
    onSuccess()
  }

  const renderInfo = (title: string, value: any, span: number = 15) => {
    return <InfoItem title={title} value={value} span={span} />
  }

  const getConfigName = (key: string): string => {
    const result = priceLabel && priceLabel.find(item => item.name === key)
    return `${result?.value || ''} ${result?.description ? '(' + result?.description + ')' : ''}`
  }

  const ConfirmQuotationModal = (
    <ConfirmQuotation
      onCloseModal={() => setShowConfirm(false)}
      onSuccess={() => {
        setShowConfirm(false)
        onGetDetail()
        onSuccess()
      }}
      visible={showConfirm}
      products={detail?.products || []}
      productsGrn={productsGrn || []}
      id={detail?.id || 0}
    />
  )

  const renderClientInfo = () => {
    return (
      <BoxWrapper>
        <Row>
          <Col md={12} xs={24}>
            <BoxTitle>ข้อมูลลูกค้า</BoxTitle>
            {renderInfo(
              'ชื่อ',
              <FranchiseTag
                text={detail?.customer?.name || ''}
                isFranchise={detail?.quotation_type === 'franchise'}
              />,
            )}
            {renderInfo('ที่อยู่', detail?.customer?.address)}
            {renderInfo('เบอร์โทรศัพท์', detail?.customer?.mobile)}
            {renderInfo('อีเมล', detail?.customer?.email)}
            {renderInfo('ประเภทลูกค้า', getConfigName(detail?.customer?.type || ''))}
          </Col>
          {detail?.customer?.is_tax && (
            <Col md={12} xs={24}>
              <BoxTitle>ข้อมูลสำหรับออกใบกำกับภาษีรูปแบบเต็ม</BoxTitle>
              {renderInfo('ชื่อ', detail?.customer?.tax_name)}
              {renderInfo('เลขประจำตัวผู้เสียภาษี', detail?.customer?.tax_number)}
              {renderInfo('ที่อยู่', detail?.customer?.tax_address)}
              {renderInfo('เบอร์โทรศัพท์', detail?.customer?.tax_mobile)}
            </Col>
          )}
        </Row>
      </BoxWrapper>
    )
  }

  const renderDeliveryInfo = () => {
    return (
      <BoxWrapper>
        <Row>
          <Col md={12} xs={24}>
            <BoxTitle>ข้อมูลที่อยู่ผู้รับ</BoxTitle>
            {renderInfo('ชื่อ', detail?.recipient_name)}
            {renderInfo('ที่อยู่', detail?.recipient_address)}
            {renderInfo('เบอร์โทรศัพท์', detail?.recipient_mobile)}
            {renderInfo('อีเมล', detail?.recipient_email)}
          </Col>
          <Col md={12} xs={24}>
            <BoxTitle>ข้อมูลการจัดส่ง</BoxTitle>
            {renderInfo('วันที่ต้องการให้จัดส่ง', formatDateWithoutTime(detail?.delivery_date || ''))}
            {renderInfo('ช่องทางจัดส่ง', formatShippingTypes(detail?.delivery_channel || ''))}
          </Col>
        </Row>
      </BoxWrapper>
    )
  }

  const renderQuotationInfo = () => {
    return (
      <BoxWrapper>
        <Row>
          <Col md={12} xs={24}>
            <BoxTitle>รายละเอียดการสั่งซื้อ</BoxTitle>
            {renderInfo('วันที่ออกใบเสนอราคา', formatDateTime(detail?.created_at || ''))}
            {renderInfo('ผู้ออกใบเสนอราคา', detail?.issuer_name)}
          </Col>
          <Col md={12} xs={24}>
            <BoxTitle> &nbsp;</BoxTitle>
            {renderInfo('หมายเหตุ', detail?.issuer_note)}
            {renderInfo('สถานะใบเสนอราคา', renderStatus(detail?.status || ''))}
            {detail?.reason && renderInfo('เหตุผล', <Reason>{detail?.reason || '-'}</Reason>)}
          </Col>
        </Row>
      </BoxWrapper>
    )
  }

  const renderFooterContent = () => {
    const status = detail?.status

    if (status == QuotationStatus.PENDING) {
      return (
        <Space size="middle" align="baseline">
          <PrimaryButton text="ยกเลิกใบเสนอราคา" btnType="Reject" onClick={onClickCancel} />
          <PrimaryButton
            btnType="Approve"
            text="สร้างรายการขาย"
            onClick={() => {
              // onCloseDrawer()
              setShowConfirm(true)
            }}
          />
        </Space>
      )
    }

    return null
  }

  const ConfirmRejectDailog = (
    <ConfirmQuestion
      title={`ยกเลิกใบเสนอราคา`}
      label="ระบุเหตุผล"
      placeholder="เช่น ออกรายการผิดพลาด..."
      confirmBtnTxt="ยืนยัน"
      isShow={rejectDialog}
      handleOk={(remark: string) => onConfirmCancel(QuotationStatus.CANCEL, remark)}
      handleCancel={() => setRejectDialog(false)}
      loading={event.IsLoading}
    />
  )

  const ConfirmCloseQuotationDailog = (
    <ConfirmQuestion
      title={`ปิดใบสั่งซื้อ`}
      label="ระบุเหตุผล"
      placeholder="เช่น ออกรายการสั่งซื้อผิดพลาด..."
      confirmBtnTxt="ยืนยัน"
      isShow={closeQuotationDialog}
      handleOk={(remark: string) => onConfirmCancel(QuotationStatus.PENDING, remark)}
      handleCancel={() => setCloseQuotationDialog(false)}
      loading={event.IsLoading}
    />
  )

  const renderStatus = (status: string) => {
    const statusResult = getQuotationStatus(status)
    return <StatusTag text={statusResult.text} color={statusResult.color} />
  }

  const renderTitle = () => {
    return <DetailHeader id={id} purchasing_no={detail?.quotation_no} detail={detail} />
  }

  return (
    <DetailDrawer
      title={renderTitle()}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={renderFooterContent()}
      width={'90%'}
      maskClosable={true}
    >
      <LoadingView isShow={detailEvent.IsLoading} />
      {ConfirmRejectDailog}
      {ConfirmCloseQuotationDailog}
      {detail && detail?.status === QuotationStatus.PENDING && ConfirmQuotationModal}
      <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
      <Row justify="space-between" gutter={[16, 8]}>
        <Col md={24} xs={24}>
          {renderQuotationInfo()}
        </Col>
        <Col md={24} xs={24}>
          {renderClientInfo()}
        </Col>
        <Col md={24} xs={24}>
          {renderDeliveryInfo()}
        </Col>
        <Col md={24} xs={24}>
          <ProductsTable
            products={detail?.products || []}
            viewMode={true}
            quotationPdfRef={quotationPDF}
            quotationLitePdfRef={quotationLitePDF}
            quotation_no={detail?.quotation_no}
            detail={detail}
            customerType={detail?.customer?.type || ''}
          />
        </Col>
        <Col md={12} xs={24}></Col>
        <Col md={8} xs={24}>
          <SummaryInfo>
            <QuotationSummay detail={detail} showVat={showVat} />
          </SummaryInfo>
        </Col>
      </Row>
      <Row ref={quotationPDF}>
        <Col span={24}>
          <QuotationPDF detail={detail} showVat={showVat} configData={configData} />
        </Col>
      </Row>
      <Row ref={quotationLitePDF}>
        <Col span={24}>
          <QuotationPDF detail={detail} isLite={true} showVat={showVat} configData={configData} />
        </Col>
      </Row>
    </DetailDrawer>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const Reason = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
`

const SummaryInfo = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  //color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  margin-right: 20px;
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectQuotationActionEvent(state),
    detail: selectQuotationDetail(state),
    detailEvent: selectQuotationDetailEvent(state),
    supplierList: selectAllSupplierList(state),
    configs: selectDatas(state),
    productsGrn: selectProductsGrnList(state),
    configList: selectConfigList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(QuotationDetail)
